import { HStack, VStack, XText } from "IZOX/_X";
import { Accessor, ColorX, LocaleX, LogicX, ZValidate } from "IZOX/STATIC";
import _ from "lodash";
import React, { useCallback, useEffect, useState } from "react";

/**
 * @typedef {import("../QForm").vstackparams} vstackparams
 * @typedef {import("IZOX/STATIC/ZValidate").fvalidate} fvalidate
 * 
 * @typedef {Object} qferror
 * @property {String} name
 * @property {any} defaultValue
 * @property {Function} _onChange
 * @property {Function} _onSetDefault
 * @property {any} formValue
 * @property {*} addOns
 * @property {fvalidate | fvalidate[]} validators
 * @property {Boolean} showAllErrors
 * @property {String} errorColor
 * @property {Number} fontSize
 * @property {Boolean} bold
 * 
 * @typedef {qferror & vstackparams} qferrorparams
 * 
 * @param {qferrorparams} param0 
 * @returns 
 */
function QFError({
  name = undefined,
  _onChange = null,
  _onSetDefault = null,
  defaultValue = undefined,
  formValue = {},
  addOns = undefined,
  updateVia = undefined, 
  updateField = undefined,
  forceUpdateField = undefined,
  performanceBoost = undefined,
  validators = [],
  showAllErrors = false,
  errorColor = ColorX.CSS("Error"),
  fontSize = 12,
  bold = false,
  ...others
}){

  const [isError, setIsError] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);

  useEffect(() => {
    let _value = Accessor.Get(formValue, name);
    let _msgs = ZValidate.GetAllErrorMessages(_value, validators);
    setIsError(!_.isEmpty(_msgs));
    setErrorMessages(_msgs);
  }, [formValue, name, validators]);

  const renderError = useCallback((o, i) => {
    return (
      <HStack key={i} fullWidth HAlign="[">
        <XText color={errorColor} fontSize={fontSize} bold={bold}>
          {LocaleX.Parse(o)}
        </XText>
      </HStack>
    );
  }, [errorColor, fontSize, bold]);

  if(_.isUndefined(name)) return null;
  if(!isError) return null;
  if(_.isEmpty(errorMessages)) return null;

  let _dis = errorMessages;
  if(!showAllErrors) {
    _dis = [errorMessages[0]];
  }

  return (
    <VStack HAlign="[" fullWidth {...others}>
      {_.map(_dis, (o, i) => renderError(o, i))}
    </VStack>
  );

}

export default React.memo(QFError, (prevProps, nextProps) => {
  let propIdentical = Accessor.IsIdentical(nextProps, prevProps);
  if(propIdentical){ return true; }
  
  let {updateVia, updateField, forceUpdateField, performanceBoost, name} = nextProps ?? {};
   
  if(updateVia !== "update") return false;

  if(performanceBoost){
    if(name.includes(updateField)){
      return false;
    }

    if(forceUpdateField?.length > 0 && LogicX.includesOneOf(name, forceUpdateField)){
      return false;
    }

    return true;
  }
  return false;
});